module.exports = __webpack_public_path__ + "static/media/add-organizer.3cdb773d.svg";